import { BaseChildStateWithDelay } from '@stateMachine/BaseChildStateWithDelay'
import GameSignals from '../../signals/GameSignals'
import gsap from 'gsap'
import { toMajorUnits } from '@/utils/CurrencyUnits'

export class FreeSpinsActivateState extends BaseChildStateWithDelay {
    public canTrigger(): boolean {
        return (
            !this._model.spinState.isHoldAndWinActive &&
            this._model.spinData.bonus &&
            (this._model.spinData.bonus.freebet_given > 0 || this._model.spinData.bonus.freebet_count > 0)
        )
    }

    public begin() {
        const coinSymbolsCount = Number((this._model.spinData?.bonus as any)?.num_coin_symbols || 0)
        const activationDelay = coinSymbolsCount >= 6 ? 2.6 : 1.5

        const data = {
            baseWinCurrency: this._model.spinData.base_win_currency,
            winCurrency: this._model.spinData.win_currency,
            symbolsPositions: this._model.spinData.bonus.freebets_position[this._model.cascadeIndex]
        }
        GameSignals.activateScatters.emit(data)

        if (this._model.spinData.bonus.bonus_win_currency > 0) {
            gsap.to(this, {
                duration: 0.5,
                onComplete: () => {
                    this._model.winCounter.countWin(this._model.spinData.bonus.bonus_win_currency, -1, false)

                    const winValue: number = this._model.spinData.win_currency - (this._model.spinData?.bonus?.bonus_win_currency || 0)

                    if (!!winValue) {
                        GameSignals.updateWinPanelValue.emit(toMajorUnits(this._model.spinData.bonus.bonus_win_currency))
                    }
                }
            })
        }

        gsap.to(this, {
            duration: activationDelay,
            onComplete: () => {
                this.end()
            }
        })
    }

    public cleanUp() {}
}
